import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
`;

export const title = styled.p`
	color: ${color.interface.blackMofiq};
	font-size: 1.8rem;
	font-weight: bold;
`;

export const containerMobile = styled.div<{
	$useBackground: boolean;
	$background: string | null;
	$isShadow: boolean;
	$backgroundColor: string;
	$heightCellPhone: string;
	$widthCellPhone: string;
}>`
	position: relative;
	min-width: 250px;
	width: ${(props) => `${props.$widthCellPhone}`};
	height: ${(props) => `${props.$heightCellPhone}`};
	border-radius: 20px;

	background-image: ${(props) =>
		props.$useBackground === true ? `url(${props.$background})` : 'none'};
	background-repeat: no-repeat;
	background-position: center; /* Center the image */
	background-size: cover; /* Resize the background image to cover the entire container */

	border-top: 7px solid black;
	border-bottom: 7px solid black;
	border-left: 7px solid black;
	border-right: 7px solid black;
	background-color: ${(props) => props.$backgroundColor};

	-webkit-box-shadow: ${(props) =>
		props.$isShadow ? ' 16px 16px 12px -13px rgba(0, 0, 0, 0.75)' : '0'};
	-moz-box-shadow: ${(props) =>
		props.$isShadow ? ' 16px 16px 12px -13px rgba(0, 0, 0, 0.75)' : '0'};
	box-shadow: ${(props) =>
		props.$isShadow ? ' 16px 16px 12px -13px rgba(0, 0, 0, 0.75)' : '0'};

	@media (max-width: 375px) {
		min-width: 250px;
	}

	@media (max-height: 650px) {
		border-top: 4.5px solid black;
		border-bottom: 4.5px solid black;
		border-left: 4.5px solid black;
		border-right: 4.5px solid black;
	}
`;

export const topMobile = styled.div<{ $useBackground: boolean }>`
	width: 100%;
	display: grid;
	grid-template-columns: 2fr 1fr 2fr;
	background-color: ${(props) =>
		props.$useBackground ? 'none' : color.interface.white};
	border-top-right-radius: 15px;
	border-top-left-radius: 15px;
`;

export const blackDiv = styled.div<{ $isShow: boolean }>`
	width: 100%;
	min-width: 110px;
	height: 20px;
	background-color: ${(props) => (props.$isShow ? 'black' : 'transparent')};

	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;

	@media (max-height: 650px) {
		height: 17px;
		min-width: 100px;
	}
`;

export const operadoraCell = styled.div<{ $useBackground: boolean }>`
	width: 100%;
	/* background-color: yellow; */
	padding-top: 5px;
	> p {
		padding-left: 1rem;
		color: ${(props) =>
			props.$useBackground ? color.interface.white : color.interface.black};
	}
`;

export const iconsCell = styled.div<{ $useBackground: boolean }>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 5px;
	padding-right: 10px;
	/* background-color: yellow; */

	> svg {
		color: ${(props) =>
			props.$useBackground ? color.interface.white : color.interface.black};
	}
`;

export const contentPhone = styled.div<{
	$withPaddingContent: boolean;
	$useBackground: boolean;
	$backgroundColor: string;
	$heightContentPhone: string;
	$showHeaderPhone: boolean;
}>`
	position: absolute;
	width: 100%;
	height: ${(props) => props.$heightContentPhone};
	padding: ${(props) => (props.$withPaddingContent ? '1rem' : '0px')};
	background-color: ${(props) =>
		props.$useBackground ? 'none' : props.$backgroundColor};
	overflow: auto;
	border-bottom-right-radius: 12px;
	border-bottom-left-radius: 12px;
	border-top-right-radius: ${(props) =>
		props.$showHeaderPhone ? '0px' : '12px'};
	border-top-left-radius: ${(props) =>
		props.$showHeaderPhone ? '0px' : '12px'};

	::-webkit-scrollbar {
		display: none; /* Oculta a barra de rolagem */
	}

	::-webkit-scrollbar {
		width: 5px; /* width of the entire scrollbar */
		height: 4px;
	}

	::-webkit-scrollbar-track {
		background: ${color.interface.white}; /* color of the tracking area */
	}

	::-webkit-scrollbar-thumb {
		background-color: ${color.interface
			.lightGray5}; /* color of the scroll thumb */
		border-radius: 20px; /* roundness of the scroll thumb */
		border: 1px solid ${color.interface.lightGray5}; /* creates padding around scroll thumb */
	}
`;
